import _request from 'tools/request'
import { logApiError } from 'tools/error'
import logger from 'tools/logger'
import { isObjectEmpty } from 'tools/object'

export const IG_API_BASE_URL = 'https://api.instagram.com'
export const IG_GRAPH_BASE_URL = `https://graph.instagram.com`

export const postShortLivedTokenPath = '/oauth/access_token'
export const getLongLivedTokenPath = '/access_token'
export const getIgUserInfoPath = '/me'
export const getIgUserMediaPath = '/me/media'

export const createApi = ({
  express,
  origin,
  apiRoot,
  igApiRoot,
  igClientSecret
}) => {
  const router = new express.Router()

  const request = async (req, res, options) => {
    logger.verbose(`[dashboard] ${req.url} requested ${JSON.stringify(options, null, 2)}`)
    const response = await _request(options)
    logger.verbose(`[dashboard] ${req.url} got response ${response.body} ${response.statusCode}`)
    logApiError({ req, response, origin, apiRoot })
    return response
  }

  const call = async ({ req, res, next, uri, method = 'GET', withAuth = false }) => {
    const options = {
      uri,
      method
    }

    // only add body and query to options if exists in the request object
    if (!isObjectEmpty(req.body)) {
      options.formData = {
        ...req.body,
        ...(withAuth ? { 'client_secret': igClientSecret } : {})
      }
    }
    if (!isObjectEmpty(req.query)) {
      options.qs = req.query
    }

    try {
      const response = await request(req, res, options)
      if (response.body) {
        const json = JSON.parse(response.body)
        return res.status(response.statusCode).json(json)
      }

      return res.status(response.statusCode).send()
    } catch (error) {
      next(new Error(error))
    }
  }

  router.post(postShortLivedTokenPath, (req, res, next) => call({ req, res, next, uri: `${IG_API_BASE_URL}${postShortLivedTokenPath}`, method: 'POST', withAuth: true }))

  router.get(getLongLivedTokenPath, (req, res, next) => call({ req, res, next, uri: `${IG_GRAPH_BASE_URL}${getLongLivedTokenPath}?client_secret=${igClientSecret}`, method: 'GET' }))

  router.get(getIgUserInfoPath, (req, res, next) => call({ req, res, next, uri: `${IG_GRAPH_BASE_URL}${getIgUserInfoPath}`, method: 'GET' }))

  router.get(getIgUserMediaPath, (req, res, next) => call({ req, res, next, uri: `${IG_GRAPH_BASE_URL}${getIgUserMediaPath}`, method: 'GET' }))

  return [igApiRoot, router]
}
